// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1CEl_","name":"Header_name__1tISk","birthday":"Header_birthday__3rLzc","skeleton":"Header_skeleton__363OR"};